export function delay(timeoutMs) {
  return new Promise(resolve => {
    setTimeout(resolve, timeoutMs);
  });
}
